import { PublicPageLayout } from "@/shared/components/layout/public-page-layout";
import { FinalCta } from "./components/final-cta";
import { Hero } from "./components/hero";
import { Lore } from "./components/lore";
import { Provocative } from "./components/provocative";
import { SiteFooter } from "./components/site-footer";
import { SiteHeader } from "./components/site-header";
import { TeaserGrid } from "./components/teaser-grid";
import { useHomeContainer } from "./container";

export function HomePage() {
  const c = useHomeContainer();
  return (
    <PublicPageLayout>
      <SiteHeader />
      <main>
        <Hero />
        <Lore />
        <TeaserGrid items={c.teaserItems} />
        <Provocative />
        <FinalCta />
      </main>
      <SiteFooter />
    </PublicPageLayout>
  );
}
